import { FC } from "react";
import { SearchWithAutocompleteWrapper } from "../../components/common/SearchWithAutocomplete/SearchWithAutocomplete.styles";
import { t } from "i18next";
import ServerSideSearchBar from "../../components/common/table/ServerSideSearchBar";
import SearchBarButtonContainer from "../../components/common/table/SearchBarButtonContainer";
import {FormControl, InputLabel, MenuItem, Select, TextField, Typography} from "@mui/material";
import GridOnIcon from '@mui/icons-material/GridOn';
import { TemplateDownloadBox } from "./Employees.styles";
import { usePermissionChecker } from "../../hooks/usePermissionChecker";
import { PermissionEntityType } from "../../types/permissionType";
import { useProcessingRequest } from "../../store/selectors/tableManagementSelector";
import Autocomplete from "@mui/material/Autocomplete";
import {GroupItem} from "../../types/groupItem";

const EMPLOYEE_TEMPLATE_URL = "/files/templates/Mitarbeiterliste.xlsx";

interface EmployeesSearchBarProps {
  handleOnSearch: (searchQuery: string) => void;
  onCreateEmployee: () => void;
  groups: GroupItem[],
  selectedGroups: GroupItem[],
  onSelectGroups: (groups: GroupItem[]) => void;
}

const EmployeesSearchBar: FC<EmployeesSearchBarProps> = ({
  handleOnSearch: onSearchHandler,
  onCreateEmployee,
  groups,
  selectedGroups,
  onSelectGroups
}) => {
  const processingRequest = useProcessingRequest();
  const { userHasPermission } = usePermissionChecker();
  const canCreateEmployees = userHasPermission(PermissionEntityType.Employees, "Create");

  return (
    <SearchWithAutocompleteWrapper>
      <ServerSideSearchBar onSearchHandler={onSearchHandler} />
      <div style={{flex: 1}}></div>
        <Autocomplete disablePortal
                      multiple
                      options={groups}
                      sx={{ width: 300 }}
                      value={selectedGroups}
                      onChange={(_, groups) => onSelectGroups(groups)}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => <TextField {...params} label={t("tableColumnHeaders.groups")} />} />
      <TemplateDownloadBox
        style={{
          filter: processingRequest ? "blur(2px)" : "none",
          transition: "filter 0.3s ease-in-out",
        }}
      >
        <GridOnIcon />
        <Typography>
          <a href={EMPLOYEE_TEMPLATE_URL}>
            {t("buttons.templateDownload")}
          </a>
        </Typography>
      </TemplateDownloadBox>
      <SearchBarButtonContainer
        showBulkDownloadButton
        showFileUploaderBox
        onCreateClick={!canCreateEmployees ? undefined : onCreateEmployee}
        style={{
          filter: processingRequest ? "blur(2px)" : "none",
          transition: "filter 0.3s ease-in-out",
        }}
      />
    </SearchWithAutocompleteWrapper>
  );
};

export default EmployeesSearchBar;